// SignupOwner.js
import { getDatabase, ref, set, update } from "firebase/database";

import { useAuth } from "../contexts/AuthContext";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Button, Form, Row, Col, Alert } from "react-bootstrap";
import Cropper from "react-cropper"; // Import Cropper component and types
import "cropperjs/dist/cropper.css"; // Import Cropper CSS
import {
  RenterVerificationRejectedEmailBody,
  getAllRenterSelectionQuestions,
  getAllRenterSignupQuestions,
  getAllRenterTextQuestions,
  getPlatformPercentages,
  newUserAddedAdminEmailBody,
  welcomeRenterEmailBody,
  sendEmail,
  sendEmailWithRetry,
  sendSMS,
  welcomeEmailBody,
  calculateAgeFromDateOfBirth,
} from "./utils";
import { notifyNewRenter } from "./utils/adminNotifications";

const SignupOwner = () => {
  const navigate = useNavigate();
  const { signup, refreshUserData, setIsSigningUp } = useAuth();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isAgeValid, setIsAgeValid] = useState(true);

  const cropperRef = useRef(null); // Create a ref to the Cropper component
  const [croppedImage, setCroppedImage] = useState(null);

  const serverUrl = process.env.REACT_APP_BASE_URL;

  const [phoneNo, setPhoneNo] = useState("");
  const [textQuestionAnswers, setTextQuestionAnswers] = useState([]);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    password: "",
    avatar: "",
    dateOfBirth: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zipCode: "",
    country: "",
  });

  const [multiChoiceQuestions, setMultiChoiceQuestions] = useState([]);
  const [allQuestionsData, setAllQuestions] = useState([]);
  const [textQuestions, setTextQuestions] = useState([]);

  // const handlePendingVerification = (event) => {
  //   setHandleVerification(event.target.checked);
  // };

  const [avatar, setAvatar] = useState(null);
  const [checkboxAnswers, setCheckboxAnswers] = useState([]);
  const [selectedAnswer, setSelectedAnswer] = useState("");

  const handleCheckboxChange = (questionText, isChecked) => {
    const existingAnswerIndex = checkboxAnswers.findIndex(
      (answer) => answer.questionText === questionText
    );

    // Corrected: Store "Yes" when checked, "No" when unchecked
    const answerValue = isChecked ? "Yes" : "No";
    setSelectedAnswer(answerValue);

    if (existingAnswerIndex !== -1) {
      setCheckboxAnswers((prevAnswers) => {
        const updatedAnswers = [...prevAnswers];
        updatedAnswers[existingAnswerIndex] = {
          questionText,
          answer: answerValue,
        };
        return updatedAnswers;
      });
    } else {
      setCheckboxAnswers((prevAnswers) => [
        ...prevAnswers,
        {
          questionText,
          answer: answerValue,
        },
      ]);
    }
  };

  const onCrop = () => {
    const cropper = cropperRef.current.cropper; // Access the Cropper instance through the ref
    setCroppedImage(cropper.getCroppedCanvas().toDataURL());
  };

  const handleUploadAvatar = async () => {
    if (croppedImage) {
      // Convert the base64 image to a Blob
      const blob = await fetch(croppedImage).then((res) => res.blob());
      console.log(blob);
      // Create FormData and append the file
      const formData = new FormData();
      formData.append("file", blob);

      try {
        const response = await fetch(`${serverUrl}/upload-featured-image`, {
          method: "POST",
          body: formData,
        });

        if (response.ok) {
          const responseData = await response.json();
          setFormData((prevUserValues) => ({
            ...prevUserValues,
            avatar: `${serverUrl}/images/${responseData.file_name}`,
          }));
          setAvatar(null);
        } else {
          console.error("File upload failed");
        }
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    } else {
      console.error("No cropped image available");
    }
  };

  const handleSelectImage = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      setAvatar(reader.result); // Set the file URL as the avatar
    };
    reader.readAsDataURL(file); // Convert the file to a data URL
  };

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const allQuestionsData = await getAllRenterSignupQuestions();
        setAllQuestions(allQuestionsData);

        console.log("allQuestionsData");
        console.log(allQuestionsData);

        const questionsData = await getAllRenterSelectionQuestions();

        const questionsArray = Object.values(questionsData);
        setMultiChoiceQuestions(questionsArray);

        const textQuestionsData = await getAllRenterTextQuestions();
        const testQuestionsArray = Object.values(textQuestionsData);
        setTextQuestions(testQuestionsArray);
      } catch (error) {
        console.error("Error fetching Questions:", error);
      }
    };

    fetchQuestions();
  }, []);

  // const handleChange = (e, question) => {
  //   const { name, value } = e.target;

  //   if (name.startsWith('question_')) {
  //     // Update textfield answers
  //     const questionIndex = parseInt(name.split('_')[1], 10);
  //     const existingAnswerIndex = textQuestionAnswers.findIndex(
  //       (answer) => answer.questionText === textQuestions[questionIndex]
  //     );

  //     if (existingAnswerIndex !== -1) {
  //       // If an answer exists, update the existing answer
  //       setTextQuestionAnswers((prevAnswers) => {
  //         const updatedAnswers = [...prevAnswers];
  //         updatedAnswers[existingAnswerIndex] = {
  //           questionText: textQuestions[questionIndex],
  //           answer: value,
  //         };

  //         return updatedAnswers;
  //       });
  //     } else {
  //       // If no answer exists, add a new answer to the array
  //       setTextQuestionAnswers((prevAnswers) => [
  //         ...prevAnswers,
  //         {
  //           questionText: textQuestions[questionIndex],
  //           answer: value,
  //         },
  //       ]);
  //     }
  //   } else {
  //     // Update other form data
  //     setFormData((prevData) => ({ ...prevData, [name]: value }));
  //   }
  //   console.log(textQuestionAnswers);
  //   console.log(formData);
  // };

  const handleChange = (e, question) => {
    const { name, value } = e.target;

    if (name.startsWith("question_")) {
      // Update textfield answers
      const questionIndex = parseInt(name.split("_")[1], 10);
      const existingAnswerIndex = textQuestionAnswers.findIndex(
        (answer) =>
          answer.questionText === allQuestionsData[questionIndex].questionText
      );

      if (existingAnswerIndex !== -1) {
        // If an answer exists, update the existing answer
        setTextQuestionAnswers((prevAnswers) => {
          const updatedAnswers = [...prevAnswers];
          updatedAnswers[existingAnswerIndex] = {
            questionText: allQuestionsData[questionIndex].questionText,
            answer: value,
          };
          return updatedAnswers;
        });
      } else {
        // If no answer exists, add a new answer to the array
        setTextQuestionAnswers((prevAnswers) => [
          ...prevAnswers,
          {
            questionText: allQuestionsData[questionIndex].questionText,
            answer: value,
          },
        ]);
      }
    } else {
      // Update other form data
      setFormData((prevData) => ({ ...prevData, [name]: value }));

      // Check date of birth validation when field is changed
      if (name === "dateOfBirth") {
        const age = calculateAgeFromDateOfBirth(value);
        if (age === null || age < 18) {
          setError("You must be 18 or above to create an account.");
          setIsAgeValid(false);
        } else {
          setError("");
          setIsAgeValid(true);
        }
      }
    }
  };

  console.log("phoneNo", phoneNo);

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      if (!phoneNo) {
        setError("Phone number is required");
        return;
      }

      const unacknowledgedCheckboxes = allQuestionsData.filter(
        (q) =>
          q.questionType === "checkbox" &&
          (!checkboxAnswers.find((a) => a.questionText === q.questionText) ||
            checkboxAnswers.find((a) => a.questionText === q.questionText).answer !== "Yes")
      );

      if (unacknowledgedCheckboxes.length > 0) {
        setError("You must check all required agreements before proceeding.");
        return;
      }

      setIsSigningUp(true);
      setError("");
      setLoading(true);

      const params = new URLSearchParams(window.location.search);
      const redirectTo = params.get("redirect_to");

      // if(!pendingVerification) {
      //   setError('You must acknowledge before proceeding.');
      //   return;
      // }

      const userCredential = await signup(formData.email, formData.password);
      const userId = userCredential.user.uid; // Assuming Firebase auth returns a user object with uid

      const platformSettings = await getPlatformPercentages();
      const userSuffixNew = parseInt(platformSettings.userSuffix) + 1;
      const bbrID = "BBR" + userSuffixNew;

      const setLastSuffix = ref(getDatabase(), `portalSettings/settingsID`);
      await update(setLastSuffix, {
        userSuffix: userSuffixNew,
      });

      var userStatus = "unset";
      var userRejectionReason = "None";

      const userAge = calculateAgeFromDateOfBirth(formData.dateOfBirth);

      if (userAge === null || userAge < 18) {
        userStatus = "Reject";
        userRejectionReason = "Age requirement does not meet (must be 18+)";
      }

      const userRef = ref(getDatabase(), `users/${userId}`);
      await set(userRef, {
        bbrId: bbrID,
        firstName: formData.firstName,
        lastName: formData.lastName,
        avatar: formData.avatar,
        email: formData.email,
        phone: phoneNo,
        role: "Renter",
        rejectionReason: userRejectionReason,
        status: userStatus,
        createdDate: new Date().toISOString(),
        address1: formData.address1,
        address2: formData.address2,
        city: formData.city,
        state: formData.state,
        zipCode: formData.zipCode,
        country: formData.country,
      });

      const userMetaRef = ref(getDatabase(), `userMeta/${userId}`);
      await set(userMetaRef, {
        dateOfBirth: formData.dateOfBirth,
        age: userAge,
        userAnswers: {
          multiChoiceQuestions: allQuestionsData
            .filter((question) => question.questionType === "checkbox")
            .map((question, index) => {
              const questionIndex = allQuestionsData.findIndex(
                (q) => q.questionText === question.questionText
              );

              return {
                questionIndex,
                question: question.questionText,
                answer: selectedAnswer,
              };
            }),
          textQuestions: allQuestionsData
            .filter((question) => question.questionType === "text")
            .map((question, index) => {
              const questionIndex = allQuestionsData.findIndex(
                (q) => q.questionText === question.questionText
              );
              return {
                questionIndex,
                question: question.questionText,
                answer:
                  textQuestionAnswers.find(
                    (answer) => answer.questionText === question.questionText
                  )?.answer || "",
              };
            }),
        },
      });

      const userFullName = formData.firstName + " " + formData.lastName;
      const subject = "Welcome Aboard! " + userFullName;
      const to = formData.email;

      const emailBodyNew = await welcomeRenterEmailBody(userFullName);
      const emailSent = await sendEmailWithRetry(to, subject, emailBodyNew);

      if (!emailSent) {
        console.error("Failed to send welcome email to:", to);
        setError("Welcome email could not be sent. Please check your email address and try again.");
        return;
      } else {
        console.log("Welcome email sent successfully to:", to);
      }

      const smsBody = `Welcome Aboard ${userFullName}, your account has been registered successfully.\n\n${process.env.REACT_APP_BASE_URL}/auth`;

      // Send SMS (non-blocking - failure won't prevent signup)
      const smsResponse = await sendSMS(formData.phone, smsBody);
      if (smsResponse.success) {
        console.log("SMS sent successfully:", smsResponse.data);
      } else {
        console.log("SMS not sent:", smsResponse.message);
      }

      notifyNewRenter(userFullName).catch((err) =>
        console.error("Failed to create admin notification:", err)
      );

      await refreshUserData();

      if (redirectTo) {
        if (redirectTo.startsWith('/')) {
          navigate(redirectTo);
        } else {
          navigate(`/listing/${redirectTo}`);
        }
      } else {
        navigate("/approval-pending");
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setIsSigningUp(false);
      setLoading(false);
    }
  }

  const [selectedOptions, setSelectedOptions] = useState([]);

  // const handleRadioChange = (questionText, option) => {
  //   // Check if an option for the same question already exists
  //   const existingOptionIndex = selectedOptions.findIndex(
  //     (selectedOption) => selectedOption.questionText === questionText
  //   );

  //   if (existingOptionIndex !== -1) {
  //     // If an option exists, update the existing option
  //     setSelectedOptions((prevOptions) => {
  //       const updatedOptions = [...prevOptions];
  //       updatedOptions[existingOptionIndex] = {
  //         questionText,
  //         option,
  //       };
  //       return updatedOptions;
  //     });
  //   } else {
  //     // If no option exists, add a new option to the array
  //     setSelectedOptions((prevOptions) => [
  //       ...prevOptions,
  //       {
  //         questionText,
  //         option,
  //       },
  //     ]);
  //   }
  // };

  const handleRadioChange = (questionText, option) => {
    // Check if an option for the same question already exists
    const existingOptionIndex = selectedOptions.findIndex(
      (selectedOption) => selectedOption.questionText === questionText
    );

    if (existingOptionIndex !== -1) {
      // If an option exists, update the existing option
      setSelectedOptions((prevOptions) => {
        const updatedOptions = [...prevOptions];
        updatedOptions[existingOptionIndex] = {
          questionText,
          option,
        };
        return updatedOptions;
      });
    } else {
      // If no option exists, add a new option to the array
      setSelectedOptions((prevOptions) => [
        ...prevOptions,
        {
          questionText,
          option,
        },
      ]);
    }
  };

  const [redirectTo, setRedirectTo] = useState("");
  const [redirectId, setRedirectId] = useState("");
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const redirect_to = params.get("redirect_to");
    if (redirect_to) {
      setRedirectTo(`?redirect_to=${redirect_to}`);
      setRedirectId(redirect_to);
    }
  }, []);

  return (
    <>
      <p className="auth-description">
        Please enter your credentials to create an account.
        <br />
        Already have an account? <Link to={`/auth${redirectTo}`}>Sign In</Link>
      </p>

      <div className="auth-credentials m-b-xxl">
        <Row>
          <Col>
            <Form onSubmit={handleSubmit}>
              {error && <Alert variant="danger">{error}</Alert>}
              <Form.Group controlId="firstName" className="mt-4">
                <Row className="mb-2">
                  <Col xs={6}>
                    <Form.Label className="form-label">First Name<span style={{ color: 'red' }}> *</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  </Col>
                  <Col xs={6}>
                    <Form.Label>Last Name<span style={{ color: 'red' }}> *</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  </Col>
                </Row>

                <Row className="mb-2">
                  <Col xs={12}>
                    <Form.Label className="form-label">Profile Picture <span style={{ color: 'gray', fontSize: '0.9em' }}>(optional)</span></Form.Label>
                    <Form.Control
                      type="file"
                      name="avatar"
                      onChange={(e) => handleSelectImage(e)}
                      accept="image/*"
                    />
                    {avatar && (
                      <>
                        <Cropper
                          src={avatar} // Image source
                          className="mt-3"
                          style={{ height: 400, width: "100%" }} // Styling for Cropper container
                          initialAspectRatio={16 / 9} // Initial aspect ratio for cropping
                          guides={false} // Display cropping guides
                          crop={onCrop} // Callback function triggered after cropping
                          ref={cropperRef} // Assign the ref to the Cropper component
                        />
                        <Button className="mt-3" onClick={handleUploadAvatar}>
                          Finish Cropping
                        </Button>
                      </>
                    )}
                  </Col>
                </Row>

                <Row className="mb-2">
                  <Col xs={6}>
                    <Form.Label>Date of Birth<span style={{ color: 'red' }}> *</span></Form.Label>
                    <Form.Control
                      type="date"
                      name="dateOfBirth"
                      value={formData.dateOfBirth}
                      className="form-control"
                      onChange={handleChange}
                      max={new Date().toISOString().split("T")[0]}
                      required
                    />
                  </Col>
                  <Col xs={6}>
                    <Form.Label>Phone<span style={{ color: 'red' }}> *</span></Form.Label>
                    <PhoneInput
                      country={"us"}
                      value={phoneNo}
                      onChange={(value) => setPhoneNo(value)}
                    />
                  </Col>
                </Row>

                <Row className="mb-2">
                  <Col xs={6}>
                    <Form.Label>Email<span style={{ color: 'red' }}> *</span></Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  </Col>
                  <Col xs={6}>
                    <Form.Label>Password<span style={{ color: 'red' }}> *</span></Form.Label>
                    <Form.Control
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  </Col>
                </Row>
                
                <Row className="mb-2">
                  <Col xs={12}>
                    <Form.Label>Address Line 1<span style={{ color: 'red' }}> *</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="address1"
                      value={formData.address1}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  </Col>
                </Row>

                <Row className="mb-2">
                  <Col xs={12}>
                    <Form.Label>Address Line 2 <span style={{ color: 'gray', fontSize: '0.9em' }}>(optional)</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="address2"
                      value={formData.address2}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </Col>
                </Row>

                <Row className="mb-2">
                  <Col xs={3}>
                    <Form.Label>City<span style={{ color: 'red' }}> *</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  </Col>
                  <Col xs={3}>
                    <Form.Label>State/Province<span style={{ color: 'red' }}> *</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="state"
                      value={formData.state}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  </Col>
                  <Col xs={3}>
                    <Form.Label>Zip Code<span style={{ color: 'red' }}> *</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="zipCode"
                      value={formData.zipCode}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  </Col>
                  <Col xs={3}>
                    <Form.Label>Country<span style={{ color: 'red' }}> *</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="country"
                      value={formData.country}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  </Col>
                </Row>
              </Form.Group>
              {allQuestionsData.map((question, index) => (
                <Form.Group key={index}>
                  {question.questionType === "checkbox" ? (
                    <>
                      <div className="d-flex mcq-renter flex-wrap">
                        <Form.Check
                          type="checkbox"
                          required
                          style={{ textAlign: "start" }}
                          label={question.questionText}
                          className="btn btn-light m-1"
                          name={`question_${index}`}
                          id={`checkbox_${index}`}
                          onChange={(e) =>
                            handleCheckboxChange(
                              question.questionText,
                              e.target.checked
                            )
                          }
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <Form.Label className="mt-3">
                        {question.questionText}
                        {question.questionText.trim().toLowerCase() === "address line 2" && (
                          <span style={{ color: 'gray', fontSize: '0.9em' }}> (optional)</span>
                        )}
                        {question.questionText.trim().toLowerCase() !== "address line 2" && (
                          <span style={{ color: 'red' }}> *</span>
                        )}
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name={`question_${index}`}
                        onChange={(e) => handleChange(e, question)}
                        required={question.questionText.trim().toLowerCase() !== "address line 2"}
                      />
                    </>
                  )}
                </Form.Group>
              ))}
              {/* {error && <Alert severity="warning">{error}</Alert>} */}
              <Row>
                <Col>
                  <div className="auth-submit mt-4">
                    <Button
                      className="mx-2"
                      variant="primary"
                      type="submit"
                      disabled={!isAgeValid}
                    >
                      Submit
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default SignupOwner;
